import { useQuery } from '@tanstack/react-query';
import { conflictService } from '@services';

/** Prefix of every Missing Contract Role worklist query; invalidating it refreshes the page and the tile. */
export const MISSING_CONTRACT_ROLE_WORKLIST_KEY = ['conflicts-worklist', 'MISSING_CONTRACT_ROLE'];

/**
 * Count of open/acknowledged Missing Contract Role conflicts for the Admin's dashboard tile.
 */
export const useMissingContractRoleCount = (enabled: boolean) =>
  useQuery({
    queryKey: [...MISSING_CONTRACT_ROLE_WORKLIST_KEY, 'count'],
    queryFn: () =>
      conflictService.getWorklist({
        conflictTypeCode: 'MISSING_CONTRACT_ROLE',
        limit: 1,
        offset: 0
      }),
    enabled
  });
